export enum UserStatus {
  'Created' = 'created',
  'Email Verified' = 'email verified',
  'Approved' = 'approved',
  'Disapproved' = 'disapproved',
  'Pending' = 'pending',
  'In Review' = 'in review',
}
